import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, NavigationEnd, Event as RouterEvent } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/services/auth.service';
import { HealthEditDialogComponent } from '../edit-health-dialog/edit-health-dialog.component';
import { AllergyDialogComponent } from '../allergy/allergy.component';
import { MedicationDialogComponent } from '../medication/medication.component';
import { AddDevicesComponent } from '../devices/devices.component';
import { format } from 'date-fns';

@Component({
    selector: 'app-healthdashbord',
    templateUrl: './healthdashbord.component.html',
    styleUrls: ['./healthdashbord.component.css'],
    standalone: false
})
export class HealthdashbordComponent {
  profileData: any;
  profileImg: string = '';
  country:any;
  height:any;
  weight:any;
  name:any;
  ethnicityList:any;
  BloodGroupList:any;
  medication:any;
  medcount = 0;
  devicecount:any;
  careplan:any;
  insurance:any;
  allergies:any;
  famhistory:any;
  medcondition:any;
  immunization:any;
  showMedication = false;
  careplanid:any;
  showCarePlan = false;
  isLoadingProfile: boolean = true;
  medicationCount: any
  lastUpdated:string = '';
  totalGoals:any[]=[];

  constructor(private dialog: MatDialog,  private toastr: ToastrService,
      private router: Router,
      private sanitizer: DomSanitizer,
      private auth: AuthService, 
      private cdr: ChangeDetectorRef
    ) {}

    
    ngOnInit(){
      
      this.getProfile();
      this.getDevices();
      this.getCarePlan();
      this.getCountLogs();
      this.getMedication();
      this.getActivityLog();
      this.profileImg = localStorage.getItem('profileImg') || '';
      this.country = localStorage.getItem('primaryCountry') || '';

    }
  
    onEditHealth(): void {
      const dialogRef = this.dialog.open(HealthEditDialogComponent, {
        width: '470px',
        panelClass: 'custom-dialog-container',
        data: this.profileData
      });
    
      dialogRef.afterClosed().subscribe(result => {
       // if (result) {
          // Update the health info
          this.getProfile();
          console.log('Updated Health Info:', result);
      //  }
      });
    }
  


    OnMedication(){
      this.showMedication = true;
    }
  
    goToCarePlan(): void {
      this.showCarePlan = true;
    }
  
    backToHealth(): void {
      this.showCarePlan = false;
      this.showMedication = false;
    }

    getActivityLog(){
      const formatted = format(new Date(), 'yyyyMMdd');

      this.auth.get_activity_feed_tilldate(formatted).subscribe((res: any) => {

        let isoString = res.data.activitylog[0].activityDate
        const formatted = format(new Date(isoString), "do MMMM yyyy");
        this.lastUpdated = formatted
      })
    }
    
    getDevices(){
      this.auth.device_list().subscribe((res:any) =>{
        this.devicecount = res.data.device.length;
        this.cdr.detectChanges();
        console.log('ddd',res);
      })
    }
    getCarePlan(){
      this.auth.get_care_plan().subscribe((res:any) =>{
        this.careplan= res.data.careplan.length;
        this.careplanid = res.data.careplan[0]?.id;
        console.log('careplan',this.careplan);
        console.log('careplanid',this.careplanid);
        this.getGoals(this.careplanid)
      })
    }

  getGoals(id: any) {
    this.auth.get_careplangoal(id).subscribe((res: any) => {
      let totalList = res.data.goal || [];
      this.totalGoals = totalList.length; // Get the count
    })
  }


    getMedication(){
      this.auth.profile_details_cat('medication').subscribe((res:any) =>{ 
        this.medication = res.data?.medication;
        //console.log('Medication List:', this.medication);
      }, error => {
        //console.error('Error fetching medication list:', error);    
      }
      );
    }

    getCountLogs(){

      this.auth.profile_details_cat('medication').subscribe((res:any) =>{   
        this.medicationCount = res.data?.medication?.length || 0;
        this.cdr.detectChanges();
        //console.log('Medication Count List:', this.medication);
      });
      this.auth.profile_details_cat('insurance').subscribe((res: any) => {
        this.insurance = res.data?.insurance?.length || 0;
        this.cdr.detectChanges();
        //console.log('Insurance Count List:', this.insurance);
      });
      this.auth.profile_details_cat('familyhistory').subscribe((res: any) => {
        this.famhistory = res.data?.familyHistory?.length || 0;
        this.cdr.detectChanges();
        //console.log('Family History Count List:', this.famhistory);
      });
      this.auth.profile_details_cat('medicalcondition').subscribe((res: any) => {
        this.medcondition = res.data?.medicalCondition?.length || 0;
        this.cdr.detectChanges();
        //console.log('Medical Condition Count List:', this.medcondition);
      });
      this.auth.profile_details_cat('allergy').subscribe((res: any) => {
        this.allergies = res.data?.allergy?.length || 0;
        this.cdr.detectChanges();
        //console.log('Allergy Count List:', this.allergies);
      });
      this.auth.profile_details_cat('immunization').subscribe((res: any) => {
        this.immunization = res.data?.immunization?.length || 0;
        this.cdr.detectChanges();
        //console.log('Immunization Count List:', this.immunization);
      });
    }

    getProfile() {
      this.isLoadingProfile = true;

      this.auth.get_image().subscribe((img: any) => {
        this.profileImg = img.data.imageUrl;
      })
      this.auth.profile_details_all().subscribe((res: any) => {
        this.profileData = res[0];
        //this.profileData = res.data.profile;
        console.log('..Profile Data:', this.profileData); 

        if(!this.profileData?.bloodGroup){
            this.onEditHealth();
        }
        
        if (this.profileData) {
          //this.name = this.profileData.firstName + ' ' + this.profileData.lastName;
          this.name = `${this.profileData?.firstName || ''} ${this.profileData?.lastName || ''}`.trim();
          // console.log('Profile Data:', this.profileData);
          // console.log('Profile Name:', this.name);

          this.medication = this.profileData.medication?.length;
          this.medcount = this.profileData.medication?.length || 0;
          this.allergies = this.profileData.allergy?.length;
          this.famhistory = this.profileData.familyHistory?.length;
          this.insurance = this.profileData.insurance?.length;
          this.medcondition = this.profileData.medicalCondition?.length;
          this.immunization = this.profileData.immunization?.length;
        } 
        else {
          // Fallback to localStorage
          const firstName = localStorage.getItem('first_name') || '';
          const lastName = localStorage.getItem('last_name') || '';
          this.name = `${firstName} ${lastName}`.trim();

          // Create a fallback profileData so template works
          this.profileData = {
            firstName,
            lastName
          };
          console.log('Profile Data not found, using localStorage values.',this.profileData);
          this.onEditHealth();
        }
        this.isLoadingProfile = false; // stop loading once data is ready
      })
    }

    getInitials(name: string): string {
      //console.log('name',name);
      if (!name) return '';
      const parts = name.trim().split(' ').filter(p => p); // remove empty
      if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
      return parts.slice(0, 2).map(p => p.charAt(0).toUpperCase()).join('');
    }
  
    showUnits(){
       if(this.country== "usa" || this.country == "united states of america"||this.country=="USA"){
        this.height ="feet"
        var show = true
        this.weight="lbs"
  
      } else {
        this.height ="cm"
        this.weight="kg"
  
      }
    }

    // Navigate to Health Log screen
    onHealthLogClick(): void {
      console.log("=== HEALTH LOG NAVIGATION DEBUG ===")
      console.log("Current route before navigation:", this.router.url)
      console.log("Attempting to navigate to: /health/health-log")

      // Direct navigation to health log
      this.router
        .navigate(["/health/health-log"])
        .then((success) => {
          console.log("Navigation result:", success)
          console.log("New route after navigation:", this.router.url)
          if (success) {
            console.log("Successfully navigated to Health Log")
            // Optional: Show success message
            // this.toastr.success("Loading Health Log...", "Navigation")
          } else {
            console.error("Navigation failed - route might not exist")
            this.toastr.error("Failed to navigate to Health Log", "Navigation Error")
          }
        })
        .catch((error) => {
          console.error("Navigation error:", error)
          this.toastr.error("Error navigating to Health Log", "Navigation Error")
        })
    }

    // Alternative navigation method (fallback)
    navigateToHealthLogAlternative(): void {
      // This bypasses any programmatic navigation issues
      //console.log("Using alternative navigation method")
      window.location.href = "/health/health-log"
    }

    openCategoryDialog(category: string){
        const dialogRef = this.dialog.open(AllergyDialogComponent, {
          width: '500px',
          height: '500px',
          data: { 
            mode: 'add',
            selected: category
          },
          disableClose: true,
          autoFocus: true,
        
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            // this.getCountLogs();
            this.router.navigate([`/health/profile/${category}`]);
          }
        });
    }


    openMedicationDialog(){
        const dialogRef = this.dialog.open(MedicationDialogComponent, {
          width: '500px',
          height: '500px',
          data: { 
            mode: 'add'
          },
          disableClose: true,
          autoFocus: true,
        
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            // this.getCountLogs()
            this.router.navigate(['/health/medication'])
          }
        });
       }

    openDeviceDialog(){
        const dialogRef = this.dialog.open(AddDevicesComponent, {
          width: '500px',
          data: { 
            mode: 'add'
          },
          disableClose: true,
          autoFocus: true,
        
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            // this.getDevices();
            this.router.navigate(['/health/devices']);
          }
        });
       }

    checkHealthUpdates(cat: any) {
      // console.log('Check Health Updates for:', cat);
      // console.log('+ Profile Data:', this.profileData);
      // console.log('careplanid:', this.careplanid);
      if (!this.profileData.weight || !this.profileData.height || !this.profileData.bloodGroup) {
        this.openAlertDialog();
        return;
      }
      else {
        if (cat == 'care-plan') {
          this.router.navigate([`/health/${cat}/${this.careplanid}`]);
        }
        else {
          this.router.navigate([`/health/${cat}`]);
        }
      }
    }

    handlePlusClick(event: Event, category: string): void {
      event.stopPropagation(); // stop the outer card's routerLink

      //console.log('+ Profile Data:', this.profileData);
      if (!this.profileData.weight || !this.profileData.height || !this.profileData.bloodGroup) {
        this.openAlertDialog();
        return;
      }

      switch (category) {
        case 'insurance':
        case 'allergy':
        case 'immunization':
        case 'medicalcondition':
        case 'familyhistory':
          this.openCategoryDialog(category);
          break;
        case 'medication':
          this.openMedicationDialog();
          break;

        case 'device':
          if (this.devicecount >= 5) {
            // navigate instead of opening dialog
            this.router.navigate(['/health/devices']);
          } else {
            // open dialog
            this.openDeviceDialog()
          }
          break;

        default:
          break;
      }
    }

    openAlertDialog(): void {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: { profData: this.profileData },
        width: '450px',
        height: '185px',
        hasBackdrop: true,
        panelClass: 'hello',
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          //console.log(result)
          // if(result){
          //   this.type=result
          //   localStorage.setItem('emailType',result)
          //   this.emailAuthentication(result)
          // }           
        }
      });
    }

}


@Component({
    selector: 'app-confirmation-dialog',
    template: `
    <div mat-dialog-content class="custom-dialog">
      <h2 class="dialog-title">Alert!</h2>
        <p class="dialog-message">
          To continue, please complete your health profile update.
        </p>
      <hr class="dialog-divider" />
      <div mat-dialog-actions class="dialog-actions">
        <button mat-button class="dialog-ok" (click)="onCloseDialog()">OK</button>
      </div>
  </div>
`,
    styleUrls: ['./healthdashbord.component.css'],
    standalone: false
})
export class ConfirmationDialogComponent {
  profData: any;
  selectedOption: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,private toast: ToastrService,
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>
  ) { }

  ngOnInit() {
      //console.log('selectedOption',this.selectedOption)
      //localStorage.removeItem('validationDone');
  }

  onCloseDialog() {
    // Only close the dialog if an option is selected
    // if (this.selectedOption) {
    //   this.closeDialog();
    // } 
    // else{
    //   this.toast.error('Please choose a Gmail or Outlook account.')
    // }
    this.closeDialog();
  }
  closeDialog() {
    this.dialogRef.close()
  }
}